import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Calendar = createReactComponent("Calendar", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "4",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2",
  key: "j76o"
}], ["line", {
  x1: "16",
  y1: "2",
  x2: "16",
  y2: "6",
  key: "xs39ck"
}], ["line", {
  x1: "8",
  y1: "2",
  x2: "8",
  y2: "6",
  key: "1t0wan"
}], ["line", {
  x1: "3",
  y1: "10",
  x2: "21",
  y2: "10",
  key: "9li9q8"
}]]]);
export default Calendar;